import { createRoot } from "react-dom/client";
import "./index.css";
import "./tailwind.css";

import App from "./App";

const root = createRoot(document.querySelector("#root")!);

root.render(<App />);
